import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";
import { MatTableModule } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatTabsModule } from "@angular/material/tabs";
import { MatSelectModule } from "@angular/material/select";
import { InvoiceHistoryComponent } from "./invoice-history.component";
import { InvoiceHistoryRoutes } from "./invoice-history.routing";
import { InvoicePreviewComponent } from "./invoice-preview/invoice-preview.component";
import { NgbRating } from "@ng-bootstrap/ng-bootstrap";
import { CancelOrderConfirmationDialogComponent } from './cancel-order-confirmation-dialog/cancel-order-confirmation-dialog.component';
import { EditDeliveryDetailsDialogComponent } from './edit-delivery-details-dialog/edit-delivery-details-dialog.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatRadioModule } from "@angular/material/radio";
import { MatDialogModule } from "@angular/material/dialog";

@NgModule({
  imports: [
    ReactiveFormsModule,
    MatTabsModule,
    MatSelectModule,
    FormsModule,
    MatInputModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    CommonModule,
    SharedModule,
    InvoiceHistoryRoutes,
    NgbRating,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatDialogModule
  ],
  declarations: [InvoiceHistoryComponent, InvoicePreviewComponent, CancelOrderConfirmationDialogComponent, EditDeliveryDetailsDialogComponent],
})
export class InvoiceHistoryModule {}
